/**
 * To Top Button 1.1
 */
jQuery(function ($) {
    /* Add class if mobile menu opened     */ 
    const mobile_nav = document.getElementsByClassName('mobile_nav')[0];
    
    mobile_nav.addEventListener('click', function() {
            document.getElementsByTagName('body')[0].classList.toggle('mobile_nav-opened');
    });
    
    const btnToTop = document.createElement('div');
    btnToTop.style.position = 'fixed';
    btnToTop.style.bottom = '5%';
    btnToTop.style.right = '0';
    btnToTop.style.backgroundColor = '#000';
    btnToTop.style.color = '#e7e7e7';
    btnToTop.style.width = '50px';
    btnToTop.style.height = '50px';
    btnToTop.style.borderRadius = '5px 0 0 5px';
    btnToTop.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.3)';
    btnToTop.style.zIndex = '1000';
    btnToTop.style.cursor = 'pointer';
    btnToTop.style.display = 'flex';
    btnToTop.style.alignItems = 'center';
    btnToTop.style.justifyContent = 'center';
    btnToTop.style.opacity = '0.6';
    btnToTop.addEventListener('mouseover', () => btnToTop.style.opacity = '0.8');
    btnToTop.addEventListener('mouseout', () => btnToTop.style.opacity = '0.6');
    btnToTop.addEventListener('click', (event) => {
        event.preventDefault(); // Prevent default anchor behavior
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });

 
    const link2 = document.createElement('a');
    link2.innerHTML = '<span class="et-pb-icon" style="font-size: 25px;">&#x3a;</span>';
    link2.style.pointerEvents = 'none';
    link2.style.textDecoration = 'none';
    link2.style.color = '#e7e7e7';
    link2.style.fontSize = '18px';
    link2.style.lineHeight = '0';

    // Append the link to the second button
    btnToTop.appendChild(link2);
   
    document.body.appendChild(btnToTop);

});